<template>
  <div
    class="z_FloatWin_vue"
    id="thediv"
    ref="thediv"
    v-show="thedivShow"
    @mouseover="clearFdAd"
    @mouseout="starFdAd"
  >
    <div
      class="win_img"
      style="background-image: url('../../assets/pcimg.jpg')"
    >
      <div
        style="
          cursor: pointer;
          text-align: right;
          font-size: 12px;
          color: #999999;
          display: inline-block;
          position: absolute;
          right: 5px;
          top: 2px;
        "
        @click="thedivShow = false"
      >
        关闭
      </div>
      <a :href="titleurl.url" target="_blank">
        <img src="../../assets/pcimg.jpg" alt="" />
        <span
          :class="{ fontS: titleurl.title.length > 22 }"
          style="
            color: white;
            position: absolute;
            font-size: 23.5px;
            left: 20px;
            top: 27%;
            margin-right: 20px;
            font-weight: bolder;
            text-align: center;
          "
        >
          {{ titleurl.title }}
        </span>
      </a>
    </div>
  </div>
</template>
<script>
var interval;
export default {
  name: "float-win",
  props: {
    titleurl: {
      type: Object,
      default() {
        return {
          title: "",
          url: "",
        };
      },
    },
  },
  components: {},
  data() {
    return {
      xPos: 0,
      yPos: 0,
      xin: true,
      yin: true,
      step: 1,
      delay: 18,
      height: 0,
      Hoffset: 0,
      Woffset: 0,
      yon: 0,
      xon: 0,
      pause: true,
      thedivShow: true,
    };
  },
  mounted() {
    interval = setInterval(this.changePos, this.delay);
  },
  methods: {
    changePos() {
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      if (document.getElementById("thediv")) {
        this.Hoffset = document.getElementById("thediv").offsetHeight; //获取元素高度
        this.Woffset = document.getElementById("thediv").offsetWidth;
      }

      // 滚动部分跟随屏幕滚动
      // this.$refs.thediv.style.left = (this.xPos + document.body.scrollLeft + document.documentElement.scrollLeft) + "px";
      // this.$refs.thediv.style.top = (this.yPos + document.body.scrollTop + document.documentElement.scrollTop) + "px";

      // 滚动部分不随屏幕滚动
      if (this.$refs.thediv?.style) {
        this.$refs.thediv.style.left =
          this.xPos + document.body.scrollLeft + "px";
        this.$refs.thediv.style.top =
          this.yPos + document.body.scrollTop + "px";
      }
      if (this.yon) {
        this.yPos = this.yPos + this.step;
      } else {
        this.yPos = this.yPos - this.step;
      }
      if (this.yPos < 0) {
        this.yon = 1;
        this.yPos = 0;
      }
      if (this.yPos >= height - this.Hoffset) {
        this.yon = 0;
        this.yPos = height - this.Hoffset;
      }

      if (this.xon) {
        this.xPos = this.xPos + this.step;
      } else {
        this.xPos = this.xPos - this.step;
      }
      if (this.xPos < 0) {
        this.xon = 1;
        this.xPos = 0;
      }
      if (this.xPos >= width - this.Woffset) {
        this.xon = 0;
        this.xPos = width - this.Woffset;
      }
    },
    clearFdAd() {
      clearInterval(interval);
    },
    starFdAd() {
      interval = setInterval(this.changePos, this.delay);
    },
  },
};
</script>
<style lang="less">
.z_FloatWin_vue {
  height: 150px;
  width: 300px;
  position: fixed; /*fixed实现绝对定位*/
  cursor: pointer;
  z-index: 99999;
}

.z_FloatWin_vue img {
  height: 150px;
  width: 300px;
}

.fontS {
  font-size: 18px !important;
}
</style>